module.exports = "https://deal-img.imgix.net/consumer/modern/inbound-code.e37ac867.png";